import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Link } from "react-router-dom";
import "./css/MenuQrCode.css";

const MENU_URL = "https://fn-studios.me/menu-demo";

const MenuQrCode = () => {
    const downloadQrCode = () => {
        const canvas = document.getElementById("menu-qr-canvas");
        if (!canvas) return;

        const url = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = url;
        link.download = "cardapio-qrcode.png";
        link.click();
    };

    return (
        <div className="menu-qr-page">
            <Link to="/menu-demo" className="menu-qr-home-button">← Voltar ao Cardápio</Link>

            <div className="menu-qr-card">
                <div className="menu-qr-plate">
                    <div className="menu-qr-plate-icon">🍽️</div>
                    <h1 className="menu-qr-plate-title">Cardápio</h1>

                    <div className="menu-qr-frame">
                        <QRCodeCanvas
                            id="menu-qr-canvas"
                            value={MENU_URL}
                            size={220}
                            level="H"
                            bgColor="#ffffff"
                            fgColor="#2b241d"
                        />
                    </div>

                    <p className="menu-qr-hint">Aponte a câmera do celular para ver o cardápio</p>
                </div>

                <button className="menu-qr-download-button" onClick={downloadQrCode}>
                    <i className="bi bi-download"></i> Baixar QR Code
                </button>

                <p className="menu-qr-url">{MENU_URL}</p>
            </div>

            <p className="menu-qr-footer-note">
                Este QR Code leva direto para o cardápio digital de demonstração — pronto para
                imprimir e usar em placas de mesa, adesivos ou cartões NFC.
            </p>
        </div>
    );
};

export default MenuQrCode;
